if (!customElements.get('tr-make-it-a-gift')) {
	class TrMakeItAGift extends HTMLElement {
		selectors = {
			toggle: '[data-tr-js-gift-toggle]',
			messageWrapper: '[data-tr-js-gift-message-wrapper]',
			message: '[data-tr-js-gift-message]',
			characterCount: 'tr-character-count'
		};

		connectedCallback() {
			this.toggleElement = this.querySelector(this.selectors.toggle);
			this.messageWrapperElement = this.querySelector(this.selectors.messageWrapper);
			this.messageElement = this.querySelector(this.selectors.message);
			this.characterCountElement = this.querySelector(this.selectors.characterCount);

			this.toggleElement?.addEventListener('change', this.onToggleChange);
			this.updateUI();
		}

		disconnectedCallback() {
			this.toggleElement?.removeEventListener('change', this.onToggleChange);
		}

		onToggleChange = () => {
			this.updateUI();
		};

		updateUI() {
			const isEnabled = this.toggleElement?.checked || false;

			if (this.messageWrapperElement) {
				this.messageWrapperElement.hidden = !isEnabled;
			}

			if (isEnabled) {
				this.characterCountElement?.updateCount?.();
			}
		}

		getGiftState() {
			const enabled = this.toggleElement?.checked || false;

			return {
				enabled,
				message: enabled ? this.messageElement?.value.trim() || '' : ''
			};
		}
	}

	customElements.define('tr-make-it-a-gift', TrMakeItAGift);
}
